import { Language } from '^/types';

export default {
  selectedCollaborators: {
    [Language.KO_KR]: '참여자',
    [Language.EN_US]: 'collaborators selected:',
  },
  changeRoles: {
    [Language.KO_KR]: '역할 변경',
    [Language.EN_US]: 'Change Roles',
  },
  enableDisableSiteLogistics: {
    [Language.KO_KR]: '현장 물류 활성화/비활성화',
    [Language.EN_US]: 'Enable/Disable Site Logistics',
  },
  remove: {
    [Language.KO_KR]: '제거',
    [Language.EN_US]: 'Remove',
  },
  close: {
    [Language.KO_KR]: '닫기',
    [Language.EN_US]: 'Close',
  },
  apply: {
    [Language.KO_KR]: '적용',
    [Language.EN_US]: 'Apply',
  },
  cancel: {
    [Language.KO_KR]: '취소',
    [Language.EN_US]: 'Cancel',
  },
  removeConfirmation: {
    [Language.KO_KR]: '선택한 참여자를 제거하시겠습니까? 제거하면 즉시 접근 권한을 잃게 됩니다.',
    [Language.EN_US]:
      'Are you sure you want to remove the selected collaborators from this project? They will lose access immediately.',
  },
  admin: {
    [Language.KO_KR]: '관리자',
    [Language.EN_US]: 'Admin',
  },
  member: {
    [Language.KO_KR]: '멤버',
    [Language.EN_US]: 'Member',
  },
  viewer: {
    [Language.KO_KR]: '뷰어',
    [Language.EN_US]: 'Viewer',
  },
} as const;
